<template>
  <div>
    <Header title="Configuration" @info="infoModalOpen = true" />

    <RetributionConfigurationsInfoModal :open="infoModalOpen" @close="infoModalOpen = false" />

    <template v-if="currentStore">
      <div :class="['mb-8', isOrganizationOrStoreAdmin ? 'grid grid-cols-1 md:grid-cols-2 gap-6' : '']">
        <SellerRetributionConfiguration />
        <ManagerRetributionConfiguration v-if="isOrganizationOrStoreAdmin" />
      </div>

      <div>
        <div class="flex justify-between items-center mb-5">
          <h3 class="text-2xl font-bold">Grille de primes</h3>
          <SecondaryButton @click="() => downloadRetributionConfigurationsPdf(currentStore.id)">
            📥 Exporter la grille de primes
          </SecondaryButton>
        </div>
        <RetributionCards
          :retributionConfigurations="retributionConfigurations"
          :showManagerRetributionConfiguration="true"
        />
      </div>
    </template>
  </div>
</template>

<script>
import { SecondaryButton } from "@estaly/ui";
import RetributionCards from "@/components/retribution/RetributionCards.vue";
import Header from "@/components/admin/retribution_configurations/Header.vue";
import RetributionConfigurationsInfoModal from "@/components/admin/retribution_configurations/RetributionConfigurationsInfoModal.vue";
import SellerRetributionConfiguration from "@/components/admin/retribution_configurations/SellerRetributionConfiguration.vue";
import ManagerRetributionConfiguration from "@/components/admin/retribution_configurations/ManagerRetributionConfiguration.vue";
import { mapActions, mapState, mapGetters } from "vuex";

export default {
  components: {
    Header,
    RetributionConfigurationsInfoModal,
    SecondaryButton,
    RetributionCards,
    SellerRetributionConfiguration,
    ManagerRetributionConfiguration,
  },

  data() {
    return {
      infoModalOpen: false,
    };
  },

  computed: {
    ...mapState("store", { currentStore: "currentStore" }),
    ...mapState("retributionConfigurations", ["retributionConfigurations"]),
    ...mapGetters("auth", ["isOrganizationOrStoreAdmin"]),
  },

  methods: {
    ...mapActions("retributionConfigurations", ["downloadRetributionConfigurationsPdf"]),
  },
};
</script>
